import { useCallback, useEffect, useState } from "react";
import { Row, Col, Space, Select } from "antd";
import HeadingComponent from "../../components/HeadingComponent";
import { getAllUsers, getRoles } from "../../firebase/queries";
import { useSelector } from "react-redux";
import CustomTable from "../../components/CustomTable";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import DeleteModal from "../../components/DeleteModal";
import UserDrawer from "./UserDrawer";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const [showDrawer, setShowDrawer] = useState(false);
  const properties = useSelector((state) => state.properties.properties);
  const user = useSelector((state) => state.auth.user);
  const [roles, setRoles] = useState([]);
  const [selectedProperties, setSelectedProperties] = useState([""]);

  const navigate = useNavigate();

  const handleDeleteUser = async (userId) => {
    console.log("USer", userId);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      columnSearch: true,
    },

    {
      title: "Email",
      dataIndex: "email",
      columnSearch: true,
    },
    {
      title: "Role",
      dataIndex: "role_name",
      render: (_, row) => row.role?.name ?? "-",
      columnSearch: true,
    },
    {
      title: "Banned",
      dataIndex: "isBanned",
      render: (_, row) => (
        <span style={{ color: row?.isBanned ? "red" : "black" }}>
          {row?.isBanned ? "Yes" : "No"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <>
            <EyeOutlined
              title="View User Details"
              className="icons_style"
              onClick={() => {
                navigate(`/user/${record?.id}`, {
                  state: { user: record },
                });
              }}
            />
            <EditOutlined
              title="Edit User Details"
              className="icons_style"
              onClick={() => {
                setUserData(record);
                displayModal();
              }}
            />
            <DeleteModal
              handleDelete={() => handleDeleteUser(record?.id)}
              title="Are you sure you want to delete this member?"
            />
          </>
        </Space>
      ),
    },
  ];

  const getUsers = async () => {
    try {
      setLoading(true);
      let response = await getAllUsers();
      const transformRes = response?.map((res) => {
        return {
          ...res,
          role_name: res?.role?.name ?? "-",
        };
      });
      setUsers(transformRes);
      setFilteredUsers(transformRes);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const hideModalCallback = useCallback(() => {
    setShowDrawer(false);
  }, []);

  const setLoadingCallback = useCallback((value) => {
    setLoading(value);
  }, []);

  const setUsersCallback = useCallback((data) => {
    setUsers((prevState) => {
      if (prevState.find((row) => row.id === data.id)) {
        const index = prevState.findIndex((row) => row.id === data.id);
        prevState.splice(index, 1, data);
        return [...prevState];
      } else {
        return [...prevState, data];
      }
    });
  }, []);
  const displayModal = () => {
    setShowDrawer(true);
  };

  useEffect(() => {
    fetchRoles();
  }, [user]);

  const fetchRoles = async () => {
    const response = await getRoles().catch((e) => {
      console.log(e);
    });
    if (response) {
      setRoles(response);
    }
  };

  const options = [
    ...properties?.map((item) => {
      return {
        label: item?.name,
        value: item?.id,
      };
    }),
  ];
  const handleChange = (value) => {
    if (value?.length === 0) {
      setFilteredUsers(users);
      setSelectedProperties([]);
      return;
    }

    const selectedValues = Array.isArray(value) ? value : value.split(",");
    setSelectedProperties(selectedValues);

    let filteredUsers = users?.filter((user) =>
      user?.assigned_property_ids?.some((id) => selectedValues.includes(id))
    );

    setFilteredUsers(filteredUsers);
  };
  return (
    <>
      <Row>
        <Col xs={24} sm={8}>
          <HeadingComponent text="Users" />
        </Col>

        <Col xs={24} sm={16} className="filter_col">
          <Select
            mode="multiple"
            allowClear
            style={{ width: "100%" }}
            placeholder="Get Users by properties"
            onChange={handleChange}
            options={options}
            showSearch
            optionFilterProp="label"
            maxTagCount="responsive"
          />
        </Col>
      </Row>
      <br />
      <CustomTable
        dataSource={filteredUsers}
        columns={columns}
        loading={loading}
      />

      {showDrawer && (
        <UserDrawer
          properties={properties}
          showDrawer={showDrawer}
          hideModal={hideModalCallback}
          setLoading={setLoadingCallback}
          setUsers={setUsersCallback}
          modalData={userData}
          roles={roles}
          user={user}
          loading={loading}
        />
      )}
    </>
  );
};

export default Users;
